module.exports = {
	"articleTitle1": "An anti-populist guide to a Valentine''s night out on the town",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "The Earle",
	"articleLink1": "https://www.michigandaily.com/content/anti-populist-guide-valentines-night-out-town",
	"articleLink2": "https://www.michigandaily.com/content/beaten-path",
	"articleSnippet1": "Feb 14, 2002 ... If you like mood lighting coupled with French and Italian provincial fare, try the \nEarle (121 W. Washington St.). Located in the basement of a ...",
	"articleSnippet2": "Oct 16, 2002 ... One of the best places to go in Ann Arbor to really get the royal treatment is The \nEarle. This upscale restauarant and bar is dark and cozy - a ...",
	"foodRecommendations": [],
	"articleTitle2": "Off the beaten path",
	"address": "121 W Washington St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.280317,
		"lng": -83.749597
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/earle.json
// module id = 867
// module chunks = 0